import React, { Component } from 'react';
import * as configActions from '../../configuration/ducks/actions';
import * as userActions from '../../user/ducks/actions';
import * as securityQuestionActions from '../../security-questions/ducks/actions';
import { connect } from 'react-redux';
import api from "../../../services/api/Api";
import { ApiPaths } from "../../../services/api/ApiPaths";
import auth from "../../user/services/Auth";
import { PropTypes } from 'prop-types';
import Util from '../../../services/util/UrlParamsUtil';
import UrlParamsUtil from '../../../services/util/UrlParamsUtil';

class ConfigInitializer extends Component {

    componentDidMount() {
        var heapAppId = localStorage.getItem('myb_heap_app_id');
        api.get(ApiPaths.GET_CONFIGURATION).then(
            (response) => {
                const configData = response.data.configurations;
                auth.initProvider(configData, Util.getQueryParams(window.location.search).clientId);

                var mybHeapId = response.data.configurations['HEAP_APPLICATION_ID']
                if (heapAppId !== mybHeapId && mybHeapId) {
                    localStorage.setItem('myb_heap_app_id', mybHeapId)
                    window.heap.load(mybHeapId, {
                        disableTextCapture: true
                    })
                }

                var gaParam = this.parseHeapIdentifier();
                if (localStorage.getItem('myb_heap_app_id') && window.heap && gaParam.ga) {
                    window.heap.identify(gaParam.uniqueGa, 'googleDeviceId');
                    window.heap.addUserProperties({
                        googleDeviceId: gaParam.ga
                    })
                }

                this.props.setConfiguration(configData);
                this.props.setSecurityQuestions(response.data.securityQuestions);
                this.props.setUserProfile(auth.getProfile());
                this.props.updateState("configInitializer");
            }
        );
    }

    parseHeapIdentifier() {
        try {
            var params = UrlParamsUtil.getQueryParams(window.location.search);

            if (!params.hrbSource || params.hrbSource == 'marketing') {
                return this.parseGAParams(params._ga);
            }

            if (params.hrbSource == 'self') {
                return this.parseGAParams(params.googleDeviceId);
            }
            throw new Error(`Invalid source option : ${params.hrbSource}`);
        }
        catch (Error) {
            console.log(Error);
        }
    }

    parseGAParams(gaParam) {
        var ga = ''
        var uniqueGa = ''

        if (gaParam) {
            ga = gaParam;
            var s = gaParam.split('-');
            if (s && s.length > 1) {
                uniqueGa = s[1]
            }
        }
        return {
            ga,
            uniqueGa
        }
    }

    render() {
        return (
            <div></div>
        );
    }
}

ConfigInitializer.propTypes = {
    updateState: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = {
    ...configActions,
    ...userActions,
    ...securityQuestionActions
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfigInitializer);